import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { postRequest } from '../../requestUtils';
import './AskQuestion.scss';
var AskQuestion = /*#__PURE__*/function (_Component) {
  function AskQuestion(props) {
    var _this;
    _classCallCheck(this, AskQuestion);
    _this = _callSuper(this, AskQuestion, [props]);
    _this.state = {
      text: ''
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(AskQuestion, _Component);
  return _createClass(AskQuestion, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.value;
      var name = target.name;
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props = this.props,
        formUrl = _this$props.formUrl,
        csrfToken = _this$props.csrfToken,
        redirectUrl = _this$props.redirectUrl;
      var data = this.state;
      return postRequest(formUrl, data, csrfToken).then(function (resp) {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          window.location.href = resp.data.redirect;
        }
      })["catch"](function (err) {
        _this2.setState({
          errors: err
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        triggerText = _this$props2.triggerText,
        submitButtonText = _this$props2.submitButtonText,
        headerTitle = _this$props2.headerTitle,
        recipientName = _this$props2.recipientName,
        triggerType = _this$props2.triggerType,
        bodyText = _this$props2.bodyText,
        buttonStyles = _this$props2.buttonStyles,
        required = _this$props2.required;
      var defaultBodyText = "Submitting a request for edits will send an email to ".concat(recipientName, " directing them to edit this proposal. ") + 'They will be able to view your comments on this page and in the email.';
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        buttonStyles: buttonStyles || 'default',
        submitButtonText: submitButtonText,
        handleSubmit: this.handleSubmit,
        submitDisabled: required && !this.state.text,
        triggerType: triggerType,
        idKey: "ask-question-modal",
        modalSize: "md"
      }, /*#__PURE__*/React.createElement("div", {
        className: "approve-invoice-modal style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, headerTitle), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mb-4"
      }, bodyText || defaultBodyText)), /*#__PURE__*/React.createElement("textarea", {
        value: this.state.text,
        className: "form-control",
        placeholder: "Type here...",
        name: "text",
        id: "text",
        rows: "4",
        onChange: this.handleInputChange
      }));
    }
  }]);
}(Component);
AskQuestion.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  recipientName: PropTypes.string,
  triggerText: PropTypes.string,
  submitButtonText: PropTypes.string,
  headerTitle: PropTypes.string,
  triggerType: PropTypes.string,
  bodyText: PropTypes.string,
  redirectUrl: PropTypes.string,
  buttonStyles: PropTypes.string,
  required: PropTypes.bool
};
AskQuestion.defaultProps = {
  triggerText: 'Request Edits',
  submitButtonText: 'Request Edits',
  headerTitle: 'Request edits on this proposal',
  triggerType: 'button',
  bodyText: null,
  redirectUrl: null,
  buttonStyles: null,
  required: true,
  recipientName: ''
};
export default AskQuestion;